import React from 'react';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { useSelectIsAppModeNewportSingleWidget } from 'app/store/general/selectors';
import { useDispatchUpdateAppSettings } from 'app/store/appSettings/dispatcher';
import AppSettingsEditor from 'appToolbar/AppSettingsEditor';
import { NumericValueEditor } from '@instinet-analytics/semantic-ui-components';

import './VolumeCurveSettings.scss';
import { useVolumeCurveConfigSlice } from 'widgets/volumeCurve/store/configuration/configSlice.ts';

export default function VolumeCurveSettings() {
    const {
        config: { barSizeInMinutes },
        dispatchConfigChanged,
    } = useVolumeCurveConfigSlice();
    const isAppModeNewportSingleWidget =
        useSelectIsAppModeNewportSingleWidget();
    const appSettings = useSelectAppSettings();
    const dispatchUpdateAppSettings = useDispatchUpdateAppSettings();

    const onNumericValueChanged = (nextBarSizeInMinutes: number) => {
        dispatchConfigChanged({ barSizeInMinutes: nextBarSizeInMinutes });
    };

    return (
        <div className="VolumeCurveSettings">
            <div className="group group-general">
                <div>
                    <div>Bar size in minutes</div>
                    <NumericValueEditor
                        value={barSizeInMinutes}
                        min={1}
                        onChange={onNumericValueChanged}
                    />
                </div>

                {isAppModeNewportSingleWidget && (
                    <AppSettingsEditor
                        appSettings={appSettings}
                        onAppSettingsChanged={dispatchUpdateAppSettings}
                        specifyVisibleControls={{
                            showChartHelp: true,
                            showTooltips: true,
                        }}
                    />
                )}
            </div>
        </div>
    );
}
